import {ApiService} from "./api-service";
import {ApiResponseDataType, ApiResponseDataValueType, Utilities} from "../common/utilities";

export async function fetchTableItems(path: string, searchAttribute: string, searchAttributeValue?: string | null, from?: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}`, {
            params: {
                [searchAttribute]: searchAttributeValue,
                from: from,
                limit: Utilities.pageSize
            },
        });
        return response.data;
    } catch (error) {
        return error as Error;
    }
}

export async function fetchTableItemsCounts(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/count`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}

export async function createTableItem(path: string, tableItem: ApiResponseDataType) {
    try {
        const response = await ApiService.getInstance().post(`/${path}`, tableItem);
        return response.data;
    } catch (e) {
        return e as Error;
    }
}

export async function updateTableItem(path: string, tableItem: ApiResponseDataType) {
    try {
        const response = await ApiService.getInstance().put(`/${path}`, tableItem);
        return response.data;
    } catch (e) {
        return e as Error;
    }
}

export async function deleteTableItem(path: string, keys: Record<string, ApiResponseDataValueType>) {
    try {
        const response = await ApiService.getInstance().delete(`/${path}`, {
            params: keys
        });
        return response.data;
    } catch (e) {
        return e as Error;
    }
}

export async function getTableGroupNames(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/group-names`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}

export async function getAllInstructorDetails(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/all-instructors`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}
// export async function  csvFileUpload(path: string, formData: FormData) {
//     try {
//         const response = await ApiService.getInstance().post(`/${path}/upload-csv`);
//         return response.data;
//     } catch (error) {
//         return error as Error;
//     }
// }
export async function getAllTagDetails(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/all-tags`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}

export async function getAllDuplicate(path: string, batchNumbers: string[]) {
    // console.log(path,batchNumbers,"apicalled")
    try {
        // Sending a POST request with the batchNumbers in the request body
        const response = await ApiService.getInstance().post(`/${path}/find-duplicates`, { batchNumbers });
        return response.data; // Assuming the response has a 'duplicates' field
    } catch (error) {
        console.error("Error fetching duplicates:", error);
        return { error: "Failed to fetch duplicates" };
    }
}


export async function getAllInstructorsDetail(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/all-instructorInfo`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}

export async function exportInstructorsCsv(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/export-csv`, {
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        return error as Error;
    }
}
export async function fetchLatestInvoice(path: string) {
    try {
        const response = await ApiService.getInstance().get(`/${path}/last-invoice`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}
export async function AddInstructor(path: string) {
    try {
        const response = await ApiService.getInstance().post(`/${path}/instructors`);
        return response.data;
    } catch (error) {
        return error as Error;
    }
}
// dynamo-db-api.ts
export async function fetchNextInstructorSno(path: string) {
  try {
    // Must be GET, not POST
    const response = await ApiService.getInstance().get(`/${path}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching next instructor SNO:", error);
    throw error;
  }
}


// dynamo-db-api.ts
export async function fetchUpdateInvoiceStatus(
        inv_no: string,
        status: string,
        issueDate?: string,
        instructor_email?: string // Make instructor_email optional
) {
        try {
            // Prepare the payload, including optional fields if provided
            const payload: { inv_no: string; status: string; issueDate?: string; instructor_email?: string } = {
                inv_no,
                status,
            };

            if (issueDate) {
                payload.issueDate = issueDate;
            }

            if (instructor_email) {
                payload.instructor_email = instructor_email; // Add instructor_email only if provided
            }

            // Make a PUT request to the API to update the invoice status (and optional fields)
            const response = await ApiService.getInstance().put(`/tc-invoice-details-trainers/update-status`, payload);

            return response.data.data; // Access the updated invoice from the response
        } catch (error) {
            console.error("Error updating invoice status:", error);
            throw error; // Rethrow the error for handling in the calling function
        }
    }